import React from 'react';
import PropTypes from 'prop-types';

// Components
import * as S from '../Styled';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.object.isRequired,
  ]),
};

const MainWrapper = ({ children }) => {
  return (
    <S.MainWrapper>
      <div>{children}</div>
    </S.MainWrapper>
  );
};

MainWrapper.propTypes = propTypes;

export default MainWrapper;
